<div class="cookie-notifier"
     *ngIf="showCoockieAgreement"
    [ngClass]="screenClasses()">
  <div class="info-wrap">
    <div class="text" [innerHTML]="'cookie-text' | customLocale: cookieOptions"></div>
    <div class="action">
      <on-ui-button [class]="'transparent'"
                    class="with-border"
                    label="{{'cookie-btn' | customLocale}}"
                    (click)="agree()">
      </on-ui-button>
    </div>
  </div>
</div>
